import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'de',
  months: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  monthsShort: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'],
  weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  weekdaysMin: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  weekdaysShort: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'D.M.YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY, HH:mm',
    'LLL-Y': 'D. MMMM, HH:mm',
    LLLL: 'dddd, D. MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D. MMMM, HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M.',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY',
    lll: 'D. MMM YYYY, HH:mm',
    'lll-Y': 'D. MMM, HH:mm',
    llll: 'ddd, D. MMM YYYY, HH:mm',
    'llll-Y': 'ddd, D. MMM, HH:mm',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'vorm.', pm: 'nachm.', AM: 'Vorm.', PM: 'Nachm.' },
  past: {
    y: { one: 'vor %s Jahr', other: 'vor %s Jahren' },
    M: { one: 'vor %s Monat', other: 'vor %s Monaten' },
    w: { one: 'vor %s Woche', other: 'vor %s Wochen' },
    d: { one: 'vor %s Tag', other: 'vor %s Tagen' },
    h: { one: 'vor %s Std.', other: 'vor %s Std.' },
    m: { one: 'vor %s Min.', other: 'vor %s Min.' },
    s: { one: 'vor %s Sek.', other: 'vor %s Sek.' },
  },
  future: {
    y: { one: 'in %s Jahr', other: 'in %s Jahren' },
    M: { one: 'in %s Monat', other: 'in %s Monaten' },
    w: { one: 'in %s Woche', other: 'in %s Wochen' },
    d: { one: 'in %s Tag', other: 'in %s Tagen' },
    h: { one: 'in %s Std.', other: 'in %s Std.' },
    m: { one: 'in %s Min.', other: 'in %s Min.' },
    s: { one: 'in %s Sek.', other: 'in %s Sek.' },
  },
  pastLong: {
    y: { one: 'vor %s Jahr', other: 'vor %s Jahren' },
    M: { one: 'vor %s Monat', other: 'vor %s Monaten' },
    w: { one: 'vor %s Woche', other: 'vor %s Wochen' },
    d: { one: 'vor %s Tag', other: 'vor %s Tagen' },
    h: { one: 'vor %s Stunde', other: 'vor %s Stunden' },
    m: { one: 'vor %s Minute', other: 'vor %s Minuten' },
    s: { one: 'vor %s Sekunde', other: 'vor %s Sekunden' },
  },
  futureLong: {
    y: { one: 'in %s Jahr', other: 'in %s Jahren' },
    M: { one: 'in %s Monat', other: 'in %s Monaten' },
    w: { one: 'in %s Woche', other: 'in %s Wochen' },
    d: { one: 'in %s Tag', other: 'in %s Tagen' },
    h: { one: 'in %s Stunde', other: 'in %s Stunden' },
    m: { one: 'in %s Minute', other: 'in %s Minuten' },
    s: { one: 'in %s Sekunde', other: 'in %s Sekunden' },
  },
  abbr: {
    y: { one: '%s J.', other: '%s J.' },
    M: { one: '%s M.', other: '%s M.' },
    w: { one: '%s W.', other: '%s W.' },
    d: { one: '%s T.', other: '%s T.' },
    h: { one: '%s Std.', other: '%s Std.' },
    m: { one: '%s Min.', other: '%s Min.' },
    s: { one: '%s Sek.', other: '%s Sek.' },
  },
  full: {
    y: { one: '%s Jahr', other: '%s Jahre' },
    M: { one: '%s Monat', other: '%s Monate' },
    w: { one: '%s Woche', other: '%s Wochen' },
    d: { one: '%s Tag', other: '%s Tage' },
    h: { one: '%s Stunde', other: '%s Stunden' },
    m: { one: '%s Minute', other: '%s Minuten' },
    s: { one: '%s Sekunde', other: '%s Sekunden' },
  },
  justNow: 'Gerade eben',
  yesterday: 'Gestern',
  today: 'Heute',
  tomorrow: 'Morgen',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY', end: 'D. MMMM YYYY' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'D.', end: 'D. MMMM YYYY' },
    dl: { start: 'D.', end: 'D. MMMM' },
    y: { start: 'D. MMM YYYY', end: 'D. MMM YYYY' },
    'y-1': { start: 'D. MMM', end: 'D. MMM YYYY' },
    m: { start: 'D. MMM', end: 'D. MMM' },
    'm-1': { start: 'D.', end: 'D. MMM YYYY' },
    d: { start: 'D.', end: 'D. MMM' },
    Y: { start: 'ddd, D. MMM YYYY', end: 'ddd, D. MMM YYYY' },
    'Y-1': { start: 'ddd, D. MMM', end: 'ddd, D. MMM YYYY' },
    M: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    D: { start: 'ddd, D.', end: 'ddd, D. MMM' },
    yt: { start: 'D. MMM YYYY, HH:mm [Uhr]', end: 'D. MMM YYYY, HH:mm [Uhr]' },
    mt: { start: 'D. MMM, HH:mm [Uhr]', end: 'D. MMM, HH:mm [Uhr]' },
    dt: { start: 'D. MMM, HH:mm [Uhr]', end: 'D. MMM, HH:mm [Uhr]' },
    t: { start: 'HH:mm', end: 'HH:mm [Uhr]' },
    'yt+to': { start: 'D. MMM YYYY, HH:mm [Uhr]', end: 'D. MMM YYYY, HH:mm [Uhr] ([GMT]Z)' },
    'mt+to': { start: 'D. MMM, HH:mm [Uhr]', end: 'D. MMM, HH:mm [Uhr] ([GMT]Z)' },
    'dt+to': { start: 'D. MMM, HH:mm [Uhr]', end: 'D. MMM, HH:mm [Uhr] ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm [Uhr] ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'de';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'vorm.' : 'Vorm.';
    } else {
      return isLowerCase ? 'nachm.' : 'Nachm.';
    }
  },
};
